// @flow

import { Box } from 'grommet/es6';
import * as React from 'react';
import Breadcrumbs from './Breadcrumbs';

const MainNav = () => (
    <Box direction="row" pad={{ right: 'medium' }} flex align="center">
        <Breadcrumbs />
    </Box>
);

export default MainNav;
